<!-- Revised on 2024/11/24 by mnavarro -->
<template>
  <li class="nav-item dropdown d-flex align-items-center pe-2 d-sm-inline">
    <a id="dropdownLanguagesMenuButton" href="#" class="p-0 nav-link text-body" data-bs-toggle="dropdown" aria-expanded="false">
      <img :src="currentFlag">
    </a>
    <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" aria-labelledby="dropdownMenuButton">
      <li class="mb-2">
        <div style="cursor: pointer;">
          <a class="dropdown-item border-radius-md" @click="setLanguage('en')">
            <div class="py-1 d-flex">
              <div class="my-auto" style="cursor: pointer;">
                <img src="/img/flags/uk.svg" class="me-2"/> {{ $t('key_language_us') }}
              </div>
            </div>
          </a>
        </div>
      </li>
      <li>
        <div style="cursor: pointer;">
          <a class="dropdown-item border-radius-md" @click="setLanguage('es')">
            <div class="py-1 d-flex">
              <div class="my-auto" style="cursor: pointer;">
                <img src="/img/flags/sp.svg" class="me-2"/> {{ $t('key_language_es') }}
              </div>
            </div>
          </a>
        </div>
      </li>
    </ul>
  </li>
</template>
  
<script>

  import { i18n, setLanguage as setI18nLanguage } from './../../../../main.js';
  import Cookies from 'js-cookie';

  export default {
    data() {
      return {
        selectedLanguage: i18n.global.locale, // Establecer el idioma actual como valor predeterminado
        currentFlag: this.getFlagForLanguage(i18n.global.locale)
      };
    },
    watch: {
      // Detecta cambios en selectedLanguage para actualizar el idioma automáticamente
      selectedLanguage(newLang) {
        this.setLanguage(newLang);
      }
    },
    methods: {
      getFlagForLanguage(language) {
        switch (language) {
          case 'es':
            return "/img/flags/sp.svg";
          default:
            return "/img/flags/uk.svg";
        }
      },
      async setLanguage(language) {
        if (i18n.global.locale === language) return;

        // Utilizamos la función global para cambiar el idioma
        await setI18nLanguage(language);

        // Actualizamos el componente
        this.selectedLanguage = language;
        Cookies.set('Picko.language', language, { expires: 365 });
        this.updateFlag();
      }, 
      updateFlag() {
        this.currentFlag = this.getFlagForLanguage(this.selectedLanguage);
      },
      created() {
        const savedLanguage = Cookies.get('Picko.language') || 'en';
        this.selectedLanguage = savedLanguage;
        this.updateFlag();
      } 
    }
  }
  </script>